import { render } from "./index.vue?vue&type=template&id=522e3c73&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "@/styles/GillSansNova.css?vue&type=style&index=0&id=522e3c73&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=522e3c73&scoped=true&lang=scss"
import "./index.vue?vue&type=style&index=2&id=522e3c73&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/tcd-partnerpage-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522e3c73"]])

export default __exports__